import LoadingPopup from 'components/LoadingPopup'
import React from 'react'
const SplashScreen = () => {
  return <LoadingPopup noText={true} />
}

export default SplashScreen
